// ANGULAR
import { Component, OnInit } from '@angular/core';

// OTHER
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

// ACTIUM
import { Infection } from 'src/app/models/infection';
import { ActInfectionStyle } from './infection-style';
import { InfectionDataService } from '../../../services/infection-service';
import { ActionType } from '../../../models/action-type';
import { ActionTypeDataService } from '../../../services/action-type-data.service';

@Component({
    selector: 'app-create-infection',
    templateUrl: './create-infection.component.html',
    styleUrls: ['./create-infection.component.scss']
})
export class CreateInfectionComponent implements OnInit {

    public infection: Infection;
    public infectionStyle: ActInfectionStyle = {
        // color: '#' + this.config.data.color,
        color: '',
        backgroundColor: ''
    };
    public actionType: any[] = [];
    public selectedActionType: ActionType = {
        actionName: '',
        id: 0,
        a20: false,
    };

    base64Image: string | ArrayBuffer | null = null;

    constructor(private ref: DynamicDialogRef,
                private config: DynamicDialogConfig,
                private infectionService: InfectionDataService,
              private actionTypeDataService: ActionTypeDataService) { }

    ngOnInit(): void {
        this.infection = this.config.data.infection;
        this.infectionStyle.backgroundColor = '#' + this.infection.bgColor;
        this.infectionStyle.color = '#' + this.infection.color;

        this.actionTypeDataService
            .getAllActionType()
            .subscribe((data: any[]) => {
                this.actionType = data;
                console.log( this.infection);
                this.selectedActionType = this.actionType.find(
                    (item) => item.id === this.infection.desinfectionActionId
                );
            });

    }

    changeBgColor(event: any): void {
        this.infectionStyle.backgroundColor = event.value;
    }

    changeTextColor(event: any): void {
       this.infectionStyle.color = event.value;
    }


    updateInfection(): void {
        this.infection.color = this.infectionStyle.color.substring(1);
        this.infection.bgColor = this.infectionStyle.backgroundColor.substring(1);
        this.infection.desinfectionActionId = this.selectedActionType.id;
        this.infectionService.updateInfection(this.infection, this.infection.id).subscribe((res: boolean) => {
            this.ref.close();
        });
    }

    addInfection(): void {
        this.infection.color = this.infectionStyle.color.substring(1);
        this.infection.bgColor = this.infectionStyle.backgroundColor.substring(1);
        this.infection.desinfectionActionId = this.selectedActionType.id;
        this.infection.id = 0;

        if(this.infection.imgPrecautions == null){
            this.infection.imgPrecautions = ''
        }

        this.infectionService.addNewInfection(this.infection).subscribe((res: boolean) => {
            this.ref.close();
        });
    }


    onFileSelected(event: Event): void {
        const fileInput = event.target as HTMLInputElement;
        if (fileInput.files && fileInput.files.length > 0) {
          const file = fileInput.files[0];
          this.convertToBase64(file);
        }

      }

      convertToBase64(file: File): void {
        const reader = new FileReader();
        reader.onload = () => {
        //   this.base64Image = reader.result;
          this.infection.imgPrecautions = reader.result;
        };
        reader.readAsDataURL(file);
      }

}
